export const startSessionRules = (inputs) => {
    return {
        agentType: {
            errors: [],
            value: inputs.agentType,
            isValid: null,
            validations: {
                required: "Agent type is required",
                inList: {
                    value: ["conversationist", "companionist", "careerist", "clarifyist"],
                    error: "Invalid agent type selected"
                }
            }
        }
    }
} 